<igx-dialog
  #errorDialog
  [closeOnEscape]="true"
  [closeOnOutsideSelect]="true"
  [rightButtonLabel]="'CLOSE' | labelTranslate"
  (rightButtonSelect)="errorDialog.close()"
  (closed)="onClosed()"
>
  <div class="error-dialog">
    <igx-dialog-title>
      <div>{{ "ERROR" | labelTranslate }}</div>
    </igx-dialog-title>
    <igx-list>
      <igx-list-item>
        <h4 igxListLineTitle>{{ "MESSAGE" | labelTranslate }}</h4>
        @if (data?.message) {
          <ng-container igxListLineTitle>
            @for (message of messageList; track message) {
              <ng-container igxListLineTitle>
                <p igxListLineTitle>
                  {{ message | messageTranslate }}
                </p>
              </ng-container>
            }
          </ng-container>
        } @else {
          <p igxListLineTitle>{{ "NONE" | labelTranslate }}</p>
        }
      </igx-list-item>

      <igx-list-item>
        <h4 igxListLineTitle>{{ "TIMESTAMP" | labelTranslate }}</h4>
        @if (data?.timestamp) {
          <ng-container igxListLineTitle>
            <p igxListLineTitle>
              {{ data?.timestamp | date: "mediumTime" }}
            </p>
          </ng-container>
        } @else {
          <p igxListLineTitle>{{ "NONE" | labelTranslate }}</p>
        }
      </igx-list-item>
    </igx-list>
  </div>
</igx-dialog>
